'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getJobById } from '@/lib/actions/jobs';
import { JobForm } from '@/components/admin/careers/JobForm';

export default function AdminCareerEditPage() {
  const { id } = useParams<{ id: string }>();
  const [job, setJob] = useState<Awaited<ReturnType<typeof getJobById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getJobById(id).then((data) => {
      setJob(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!job) {
    return <Navigate to="/admin/careers" replace />;
  }

  return <JobForm initialData={job} />;
}
